<main class="container-fluid">
  <section class="sec-main p-0 m-0">
    <div class="row vh-100">
      <div class="col-sm-6 p-5 d-flex align-items-center">
        <div class="m-3">
          <h2>Account Activation</h2>

          <p class="my-5">
            Thank you for registration. An activation link has been sent to your email. Please activate your account to login.
          </p>

          <button type="button" class="btn btn-primary btn-w" style="width: 250px">Send the activation link again</button>
        </div>
      </div>
      <div class="col-sm-6 main-signup-pic">

      </div>
    </div>
  </section>
</main>
